import { useMemo } from 'react';
import { ErrorInterface } from '../../../types/errors';
import { Table } from '../Table';
import { IRow } from '../../../types/table';
import { omit } from 'lodash';

interface UploadErrorProps {
  errors: ErrorInterface[];
}

const tableColumns = [
  { identifier: 'locationName', title: 'Location Name' },
  { identifier: 'columnInError', title: 'Column in Error' },
  { identifier: 'error', title: 'Error' },
];

const UploadErrors = ({ errors }: UploadErrorProps) => {
  const tableData: IRow = useMemo(() => {
    return errors.reduce((acc, currentValue, index) => {
      acc[index.toString()] = omit(currentValue, 'row');
      return acc;
    }, Object.assign({}));
  }, []);

  return (
    <div className='w-full flex flex-col justify-start items-center pb-6'>
      <Table
        columns={tableColumns}
        data={tableData}
        dataTestIds={{ table: 'error-table', row: 'upload-error-row' }}
      />
    </div>
  );
};

export default UploadErrors;
